import { useState, useCallback, useEffect } from "react";

// @material-ui/core components
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  FormLabel,
  Grid,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";

import makeStyles from "@material-ui/styles/makeStyles";

// @material-ui/lab components
import Alert from "@material-ui/lab/Alert";
import Skeleton from "@material-ui/lab/Skeleton";

// Karsten
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { getNotificationsPermission } from "lib/firebase";
import Api from "lib/api/httpRequestHelper";

const useStyles = makeStyles({
  icon: {
    display: "flex",
    alignItems: "center",
  },
  message: {
    fontSize: "0.8rem",
  },
});

const DialogChangePassword = ({ open, handleClose }) => {
  const isMobile600 = isMobile600();

  const [submitting, setSubmitting] = useState(false);
  const classes = useStyles();
  const snackbar = useSnackbar();
  const [notificationsPermission, setNotificationsPermission] = useState(true);
  const [notificationTopics, setNotificationTopics] = useState(null);
  const [selectedTopics, setSelectedTopics] = useState([]);

  const fetchNotificationTopics = useCallback(async () => {
    return await Api.get(
      "list-topic-notification-user",
      "notification",
      "",
      true
    )
      .then((res) => {
        const activeTopics = res.Result.filter(
          (topic) => topic.DtInsUser && topic.DtInsUser.length > 0
        ).map((topic) => topic.IdNotificacaoTopico);

        setSelectedTopics(activeTopics);
        setNotificationTopics(res.Result);
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
      });
  }, [snackbar]);

  const updateNotificationTopics = useCallback(async () => {
    setSubmitting(true);

    return await Api.post(
      "update-topic-notification-user-inscribe",
      "notification",
      { idsTopicos: [0, ...selectedTopics].join(",") },
      true
    )
      .then((res) => {
        snackbar.showMessage(`Notificações configuradas com sucesso!`, {
          severity: "success",
        });
        setNotificationTopics(res.Result);
        handleClose();
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
      })
      .finally(() => setSubmitting(false));
  }, [handleClose, selectedTopics, snackbar]);

  const handleNotifyOptionsChange = useCallback(
    (topicId) => {
      if (selectedTopics.includes(topicId)) {
        setSelectedTopics(selectedTopics.filter((topic) => topic !== topicId));
      } else {
        setSelectedTopics([...selectedTopics, topicId]);
      }
    },
    [selectedTopics]
  );

  const submit = useCallback(async () => {}, []);

  useEffect(() => {
    getNotificationsPermission()
      .then(() => {
        setNotificationsPermission(true);
      })
      .catch(() => setNotificationsPermission(false));

    fetchNotificationTopics();
  }, [fetchNotificationTopics]);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          <span>
            <Typography id="alert-dialog-title" variant="h3" component="h3">
              Notificações
            </Typography>
          </span>
        </DialogTitle>
        <form onSubmit={submit}>
          <DialogContent style={{ padding: "0 1.5rem" }}>
            <Typography id="alert-dialog-description" variant="h4">
              Configure as notificações que você deseja receber de acordo com as
              opções abaixo
            </Typography>
            <br />
            <Grid container>
              <Grid item xs={12}>
                <FormLabel component="legend">
                  Quero ser notificado sobre:
                </FormLabel>
                <div
                  role="presentation"
                  style={
                    isMobile600
                      ? { display: "flex", flexDirection: "column" }
                      : {}
                  }
                >
                  {notificationTopics ? (
                    notificationTopics.map((topic, index) => {
                      return (
                        <FormControlLabel
                          key={index}
                          control={
                            <Checkbox
                              checked={selectedTopics.includes(
                                topic.IdNotificacaoTopico
                              )}
                              onChange={() =>
                                handleNotifyOptionsChange(
                                  topic.IdNotificacaoTopico
                                )
                              }
                              color="primary"
                              disabled={submitting}
                            />
                          }
                          label={<FormLabel>{topic.Nome}</FormLabel>}
                        />
                      );
                    })
                  ) : (
                    <Skeleton style={{ marginBottom: "1rem" }} />
                  )}
                </div>
              </Grid>
              {!notificationsPermission && (
                <Grid item xs={12}>
                  <Alert
                    classes={{ icon: classes.icon, message: classes.message }}
                    severity="warning"
                  >
                    Para receber as notificações é preciso habilitar as
                    notificações do seu navegador.
                  </Alert>
                </Grid>
              )}
            </Grid>
            {submitting && (
              <div style={{ marginTop: "1rem" }}>
                <span>Salvando configurações...</span>
                <LinearProgress />
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Grid item xs={isMobile600 && 12}>
              <Button
                fullWidth
                component={Box}
                onClick={handleClose}
                disabled={submitting}
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item xs={isMobile600 && 12}>
              <Button
                fullWidth
                component={Box}
                variant="contained"
                type="submit"
                disabled={submitting}
                onClick={updateNotificationTopics}
              >
                Confirmar
              </Button>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default DialogChangePassword;
